import styled from 'styled-components';

/* Mixins */
import { FlexSpaceBetween, WebFontCaption1 } from 'styles/Mixins';

/* Utils */
import { assignIfDefined } from 'styles/Utils';

export const ProgressBarWrapper = styled.div`
  ${FlexSpaceBetween}
  ${WebFontCaption1}
  align-items: center;
`;

export const ProgressBarBackground = styled.div`
  display: flex;
  height: 8px;
  border-radius: 8px;
  margin-right: 10px;
  ${({ theme }) => `
    background: ${theme.Grey5};
  `};
`;

export const ProgressBar = styled.div<{ width?: string }>`
  display: flex;
  justify-content: flex-start;
  border-radius: 8px;
  ${({ theme }) => `
    background: ${theme.darkCobalt};
  `};
  min-width: 8px;
  ${assignIfDefined('width')};
`;
